module.exports = __webpack_public_path__ + "static/media/truck-plow.c63a4d6d.svg";